import { render, staticRenderFns } from "./editDistance.vue?vue&type=template&id=bf58e42a&scoped=true"
import script from "./editDistance.vue?vue&type=script&lang=js"
export * from "./editDistance.vue?vue&type=script&lang=js"
import style0 from "./editDistance.vue?vue&type=style&index=0&id=bf58e42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf58e42a",
  null
  
)

export default component.exports